import { TCaseObject } from "../../../services/api/instances/casesApi/types";

export const buildCaseMarkdown = (caseObject: TCaseObject): string => {
  const {
    case_info,
    case_artifacts_chain,
    case_transform_method,
    case_metadata,
  } = caseObject;

  const sections: string[] = [
    `# ${case_info.name}`,
    "---",
    `## Описание кейса`,
    case_info.task_description,
    "",
    `## Цепочка артефактов`,
    `**Входной артефакт:** ${case_artifacts_chain.input_artifact}\n`,
    `**Выходной артефакт:** ${case_artifacts_chain.output_artifact}\n`,
    `**Потребитель:** ${case_artifacts_chain.consumer}\n`,
    "",
    `## Методы трансформации`,
    `**Знания:** ${case_transform_method.knowledge}\n`,
    `**Атрибуты выходного артефакта:** ${case_transform_method.output_attributes}\n`,
    "",
    `## Дополнительно`,
    `**Экономический эффект:** ${case_metadata.feasibility.split(" | ")[0]}\n`,
    `**Проект для личной эффективности:** ${case_metadata.personal_effectiveness ? "Да" : "Нет"}`,
  ];

  return sections.join("\n");
};
